
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinhinmumbai() {



    const cardData =
    {
        keyword: 'Cab Services for Corporate Travellers in Mumbai',
        heading: 'etravo :  Cab Services for Corporate Travellers in Mumbai',
        headingDescription: 'eTravo offers premium Cab Services for Corporate Travellers in Mumbai, ensuring seamless, safe, and punctual travel across the city’s business hubs. Whether it’s airport pickups, inter-office transfers, client visits, or executive movements, our well-maintained fleet and trained chauffeurs deliver a professional travel experience. With features like real-time GPS tracking, flexible scheduling, and business-class comfort, eTravo is the trusted mobility partner for corporates operating in Mumbai’s dynamic business environment.',

        top: 'Top Places to Visit in Mumbai with etravo',
  "topPlaces": [
    {
      "title": "Gateway of India",
      "description": "An iconic arch-monument built in 1924 to commemorate the visit of King George V and Queen Mary. Located on the waterfront in Colaba, it serves as a popular gathering spot and starting point for ferries to Elephanta Island."
    },
    {
      "title": "Marine Drive",
      "description": "A 3-kilometer-long promenade along the Arabian Sea, known for its sweeping views and Art Deco buildings. At night, the streetlights resemble a necklace, earning it the nickname 'Queen's Necklace'."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
      "description": "A UNESCO World Heritage Site and historic railway station, showcasing Victorian Gothic architecture. It's one of Mumbai's busiest train stations and a testament to the city's colonial past."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these UNESCO-listed rock-cut caves date back to the 5th century and are primarily dedicated to Lord Shiva. Accessible by ferry from the Gateway of India."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A vast green oasis in the northern part of Mumbai, offering wildlife sightings, nature trails, and the ancient Kanheri Caves carved into basalt rock formations."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "A revered mosque and tomb situated on an islet off the coast of Worli. Connected to the mainland by a narrow causeway, it's a significant pilgrimage site for people of all faiths."
    },
    {
      "title": "Juhu Beach",
      "description": "One of Mumbai's most famous beaches, popular for its street food stalls offering local delicacies like bhel puri and pav bhaji, and a favorite spot for watching sunsets."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
      "description": "Formerly known as the Prince of Wales Museum, this institution houses a vast collection of artifacts, including sculptures, decorative arts, and natural history exhibits."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "An architectural marvel, this cable-stayed bridge connects the suburbs of Bandra and Worli, significantly reducing travel time and offering panoramic views of the city skyline."
    },
    {
      "title": "Colaba Causeway",
      "description": "A bustling street market in South Mumbai, known for its eclectic shops, cafes, and vibrant atmosphere, making it a shopper's paradise and a cultural hotspot."
    }
  ],
    "services": [
    {
      "name": "Corporate Cabs for Business Travelers in Mumbai",
      "description": "eTravo provides dependable corporate cab services for business travelers in Mumbai, ensuring smooth and stress-free travel across the city. Whether you're commuting to meetings, client sites, or airport transfers, our well-maintained fleet and trained chauffeurs offer timely, professional, and comfortable rides. Ideal for daily business mobility and visiting executives alike."
    },
    {
      "name": "AC Cab Hire for Corporate Clients Mumbai",
      "description": "Ensure your clients and team travel in comfort with eTravo’s AC cab hire services in Mumbai. Our fleet includes sedans, hatchbacks, and premium vehicles—all equipped with air-conditioning, clean interiors, and professional drivers. Whether for conferences, airport pickups, or city tours, we offer hourly and full-day bookings tailored to your company’s transport needs."
    },
    {
      "name": "Executive Car Rental Services in Mumbai",
      "description": "eTravo offers high-end executive car rental services in Mumbai for corporate professionals who prioritize luxury and convenience. Choose from our fleet of premium sedans and SUVs for board meetings, VIP client visits, and business travel. Enjoy features like plush seating, Wi-Fi, bottled water, and well-groomed chauffeurs—perfect for executives on the move."
    },
    {
      "name": "Daily Corporate Commute Cabs in Mumbai",
      "description": "Streamline your daily employee commute in Mumbai with eTravo’s dedicated corporate cab services. We provide shift-based scheduling, or dedicated cab options for staff. Our GPS-enabled vehicles, punctual drivers, and central dispatch system help businesses maintain efficient employee transport while reducing travel stress and absenteeism."
    },
    {
      "name": "Luxury Cabs for Business Meetings in Mumbai",
      "description": "Make the right impression with eTravo’s luxury cab services for business meetings in Mumbai. Whether you’re hosting international clients or sending executives across the city, we provide access to high-end sedans and chauffeur-driven vehicles that offer elegance, comfort, and class. Book by the hour or day for a refined and professional travel experience."
    },
    {
      "name": "Cab Booking for Corporate Travel Mumbai",
      "description": "With eTravo, corporate cab booking in Mumbai is fast, easy, and reliable. Our digital and phone booking options allow businesses to schedule one-way, round trip, or on-demand cabs for meetings, airport runs, and intra-city travel. Our services are supported by a real-time tracking system and dedicated account managers to ensure smooth travel operations."
    },
    {
      "name": "Safe & Reliable Cab Services for Executives in Mumbai",
      "description": "eTravo offers safe and reliable cab services in Mumbai for executives who require punctuality, privacy, and professionalism. Our drivers undergo background checks and regular training to deliver a secure travel environment. Whether for regular routes or VIP travel, we prioritize your team’s safety with sanitized vehicles, route monitoring, and 24/7 support."
    }
  ],
  "tableData": [
    ["Corporate Cabs for Business Travelers in Mumbai", "AC Cab Hire for Corporate Clients Mumbai"],
    ["Executive Car Rental Services in Mumbai", "Daily Corporate Commute Cabs in Mumbai"],
    ["Luxury Cabs for Business Meetings in Mumbai", "Cab Booking for Corporate Travel Mumbai"],
    ["Safe & Reliable Cab Services for Executives in Mumbai", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Premium Corporate Cab Services in Mumbai",
        "WhyChoosedescription": "eTravo provides high-quality cab services designed exclusively for corporate travelers in Mumbai. Whether you're attending business meetings in Bandra-Kurla Complex, catching a flight from Mumbai Airport, or heading to Nariman Point, our services ensure you travel comfortably, efficiently, and professionally across the city."
    },
    {
        "WhyChooseheading": "Well-Maintained Executive Fleet",
        "WhyChoosedescription": "We offer a wide range of executive cabs including sedans, SUVs, and luxury vehicles—all equipped with air-conditioning, clean interiors, Wi-Fi (on request), mobile charging ports, and bottled water. Each vehicle is maintained to high standards, ensuring a comfortable and seamless ride for corporate professionals."
    },
    {
        "WhyChooseheading": "Trained Chauffeurs with Corporate Etiquette",
        "WhyChoosedescription": "Our drivers are professionally trained and adhere to corporate etiquette. They are well-dressed, courteous, and experienced in handling business travelers. With in-depth knowledge of Mumbai’s commercial districts and traffic shortcuts, they ensure timely arrivals and smooth journeys with minimal disruption."
    },
    {
        "WhyChooseheading": "Punctual Pickups and Flight/Meeting Coordination",
        "WhyChoosedescription": "Time is crucial for business travelers. That’s why we offer highly reliable and punctual cab services with real-time tracking and timely alerts. Whether you're heading to a high-stakes meeting or catching a flight, we ensure you arrive on time—every time—without stress or delay."
    },
    {
        "WhyChooseheading": "Transparent Corporate Billing and GST Invoicing",
        "WhyChoosedescription": "eTravo supports corporate clients with clear and professional billing structures. We offer GST-compliant invoicing, centralized billing for companies, and detailed ride reports—making expense tracking and reimbursements hassle-free for both individual travelers and admin teams."
    },
    {
        "WhyChooseheading": "24/7 Availability for Dynamic Business Schedules",
        "WhyChoosedescription": "Mumbai’s business never stops—and neither do we. eTravo offers 24/7 cab services for corporate travelers to accommodate early-morning flights, late-night meetings, or unexpected travel changes. Our operations team is always on standby for urgent requests and last-minute bookings."
    },
    {
        "WhyChooseheading": "Easy Booking via App, Web, or Phone",
        "WhyChoosedescription": "Booking a corporate cab in Mumbai has never been easier. With eTravo, you can schedule a ride through our mobile app, website, or by calling our support team. We provide instant confirmation, driver details, and ETA—all within minutes for your convenience and peace of mind."
    },
    {
        "WhyChooseheading": "Custom Travel Plans for Business Executives and Teams",
        "WhyChoosedescription": "Whether you're a frequent solo traveler or coordinating transport for an entire delegation, eTravo offers custom travel plans tailored to your specific business needs in Mumbai. From airport transfers to daily business appointments, we handle all logistics so you can stay focused on what matters—your work."
    }
]



























    }

// Cab Services for Corporate Travellers in Mumbai – eTravo

const faqData = [
    [
        {
            question: 'What kind of cab services does eTravo offer for corporate travellers in Mumbai?',
            answer: 'eTravo offers premium cab services for corporate travellers in Mumbai, including point-to-point transfers, airport pickups, meeting transportation, and hourly rentals for executives and business teams.',
        },
        {
            question: 'Are your cabs suitable for VIP and executive travel in Mumbai?',
            answer: 'Yes, we provide high-end sedans and SUVs with professional chauffeurs, ideal for executive travel, board meetings, and corporate hospitality in Mumbai’s business districts.',
        },
        {
            question: 'Can eTravo support daily transportation for employees across Mumbai?',
            answer: 'Absolutely. We manage scheduled employee transport with fixed routes and timings, covering offices across South Mumbai, BKC, Andheri, Navi Mumbai, and beyond.',
        },
        {
            question: 'Do your corporate cabs come with GPS and tracking features?',
            answer: 'Yes, all eTravo cabs are GPS-enabled. Corporate clients receive access to real-time tracking, trip history, driver details, and automated reporting for accountability and safety.',
        },
        {
            question: 'Can we book eTravo cabs for client visits or site inspections in Mumbai?',
            answer: 'Yes, we offer flexible cab booking for short business trips, client site visits, or audits — ensuring timely arrivals and professional service throughout the journey.',
        },
        {
            question: 'Is dedicated support available for corporate clients in Mumbai?',
            answer: 'Yes, we assign an account manager to handle all bookings, invoicing, driver coordination, and day-to-day transport support for corporate clients in Mumbai.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Rao',
        designation: 'Admin Lead, ApexCom India Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has transformed our business travel experience in Mumbai. Their cabs are always on time, clean, and the drivers are professional. Ideal for executive movement across the city.”',
    },
    {
        name: 'Ms. Neeta Bhatia',
        designation: 'HR Manager, IntegraTech Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for client pickups, airport transfers, and internal meetings across Mumbai. The service is seamless, cost-effective, and always professionally handled.”',
    },
];

















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Services for Corporate Travellers in Mumbai",
  "image": "https://www.etravo.in/images/keyword/cab-services-corporate-travellers-mumbai.jpg",
  "description": "Book reliable cab services for corporate travellers in Mumbai with eTravo. Choose from AC cabs, executive car rentals, and luxury vehicles for business meetings, daily commutes, and safe corporate travel.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-services-for-corporate-travellers-in-mumbai"
  }
};



    return (
        <div>


<Helmet>
  <title>Cab Services for Corporate Travellers in Mumbai | Executive & AC Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services for corporate travellers in Mumbai with eTravo. Executive AC cabs, luxury vehicles, and safe, reliable transport for business meetings and daily commutes." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/13.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinhinmumbai;